import { formatDate } from 'src/lib/time';
import type { EditorialSource } from 'src/types/editorial';

/** The external link is always visible, never behind hover (Design System §3.1). */
export function SourceCard({ source }: { source: EditorialSource }) {
  return (
    <article className="source-card">
      <header className="source-card__head">
        <span className="source-card__publisher">{source.publisher || 'Editor desconocido'}</span>
        <span className="source-card__class">{source.source_class}</span>
      </header>
      <p className="source-card__title">{source.title || source.canonical_url}</p>
      <a className="source-card__url" href={source.canonical_url} target="_blank" rel="noreferrer noopener">
        {source.canonical_url}
      </a>
      <footer className="source-card__foot mono">
        <span>recuperada {formatDate(source.retrieved_at)}</span>
        {source.published_at && <span>publicada {formatDate(source.published_at)}</span>}
        <span>grupo {source.provenance_group}</span>
      </footer>
    </article>
  );
}
